var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 25.9",
    style: {
      enableBackground: "new 0 0 36 25.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:0.7802;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,10.6h27.6c1.5,0,2.7,1.2,2.7,2.7v5.9c0,0.5-0.4,0.9-0.9,0.9H2.5c-0.5,0-0.9-0.4-0.9-0.9v-5.9 C1.6,11.8,2.8,10.6,4.2,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,4.3c0.7-1.2,1.9-1.9,3.2-1.9h14.7c1.4,0,2.6,0.8,3.3,2.1l2.9,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,22.4c0,0.8-0.6,1.4-1.4,1.4h-4.5c-0.8,0-1.4-0.6-1.4-1.4v-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,22.4c0,0.8-0.6,1.4-1.4,1.4H4.3c-0.8,0-1.4-0.6-1.4-1.4v-2.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8.6,
    cy: 15.3,
    rx: 2.1,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 27.6,
    cy: 15.3,
    rx: 2.1,
    ry: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCount);
export default __webpack_public_path__ + "static/media/single-count.216af8d4591b546afd5962a791cc0a04.svg";
export { ForwardRef as ReactComponent };